var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"png-sprite-icon",class:{ disabled: _vm.disabled },style:(_vm.spriteStyle),attrs:{"title":_vm.title}})
}
var staticRenderFns = []

export { render, staticRenderFns }